// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js!../node_modules/@lumino/widgets/style/index.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../node_modules/css-loader/dist/cjs.js!../node_modules/@lumino/default-theme/style/index.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: 0;
  padding: 0;
  overflow: hidden;
  background-color: var(--background-color);
  color: var(--text-color);
}

body[data-theme="light"] {
  --background-color: #ffffff;
  --text-color: #000000;
  --primary-color: #007aff;
  --hover-color: #f0f0f0;
  --border-color: #ccc;
  --menu-active-bg: #007aff;
  --menu-active-text: #ffffff;
  --tab-active-bg: #e0e0e0;
  --tab-active-text: #000000;
}

body[data-theme="dark"] {
  --background-color: #1e1e1e;
  --text-color: #d4d4d4;
  --primary-color: #0a84ff;
  --hover-color: #2a2a2a;
  --border-color: #3c3c3c;
  --menu-active-bg: #0a84ff;
  --menu-active-text: #ffffff;
  --tab-active-bg: #2d2d2d;
  --tab-active-text: #ffffff;
}

body[data-theme="high-contrast"] {
  --background-color: #000000;
  --text-color: #ffffff;
  --primary-color: #ffff00;
  --hover-color: #1a1a1a;
  --border-color: #ffffff;
  --menu-active-bg: #ffff00;
  --menu-active-text: #000000;
  --tab-active-bg: #ffffff;
  --tab-active-text: #000000;
}

#menuBar {
  flex: 0 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: var(--background-color);
  border-bottom: 1px solid var(--border-color);
}

#menuBar .lm-MenuBar-item {
  color: var(--text-color);
}

#menuBar .lm-MenuBar-item.lm-mod-active,
#menuBar .lm-MenuBar-item:active,
#menuBar .lm-MenuBar-item:hover {
  background-color: var(--menu-active-bg);
  color: var(--menu-active-text);
}

#themeToggleButton {
  margin-right: 10px;
  padding: 4px;
  background-color: transparent;
  border: none;
  cursor: pointer;
  font-size: 16px;
  color: var(--text-color);
}

#themeToggleButton.light-theme-icon::before {
  content: "\\f185";
  font-family: "Font Awesome 5 Free";
  font-weight: 900;
}

#themeToggleButton.dark-theme-icon::before {
  content: "\\f186";
  font-family: "Font Awesome 5 Free";
  font-weight: 900;
}

#themeToggleButton.high-contrast-theme-icon::before {
  content: "\\f0eb";
  font-family: "Font Awesome 5 Free";
  font-weight: 900;
}

#main {
  flex: 1 1 auto;
  display: flex;
  flex-direction: row;
  overflow: hidden;
}

#leftPanel {
  width: 300px;
  min-width: 200px;
  border-right: 1px solid var(--border-color);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background-color: var(--background-color);
}

/* Adjust the CommandPalette styles */
#leftPanel > .lm-CommandPalette {
  /* Remove height: 100%; */
  flex: 0 0 auto;
  min-height: 250px;
  overflow: auto;
  z-index: 1;
  border: 0px;
}

/* Ensure the directory-viewer-widget fills the remaining space */
#leftPanel > .directory-viewer-widget {
  flex: 1 1 auto;
  overflow: auto;
  z-index: 0;
  border-top: 1px solid var(--border-color);
}

#palette {
  min-width: 300px;
  border-right: 1px solid var(--border-color);
  background-color: var(--background-color);
  color: var(--text-color);
}

#dock {
  padding: 4px;
  flex: 1 1 auto;
  overflow: auto;
  background-color: var(--background-color);
  color: var(--text-color);
}

.content {
  min-width: 50px;
  min-height: 50px;
  display: flex;
  flex-direction: column;
  border: 1px solid var(--border-color);
  border-top: none;
  background: var(--background-color);
}

.content > div {
  flex: 1 1 auto;
  border: 1px solid var(--border-color);
  overflow: auto;
}

.content input {
  margin: 8px;
}

.directory-viewer-widget {
  padding: 10px;
  overflow: auto;
  background-color: var(--background-color);
  font: 13px Helvetica, Arial, sans-serif;
  color: var(--text-color);
}

/* Add the new styles below */

.directory-viewer-container {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  overflow: auto;
}

.directory-tree {
  list-style-type: none;
  margin: 0;
  padding: 0;
}

.directory-tree ul {
  list-style-type: none;
  margin: 0;
  padding-left: 20px;
}

.directory-item {
  cursor: pointer;
  user-select: none;
  position: relative;
  padding: 4px 0;
  color: var(--text-color);
}

.directory-item:hover {
  background-color: var(--hover-color);
}

.directory-item .directory-icon {
  margin-right: 5px;
}

.directory-item.collapsed > ul {
  display: none;
}

.file-selected {
  background-color: var(--primary-color);
}

.fa-folder,
.fa-folder-open,
.fa-file {
  width: 16px;
  display: inline-block;
  text-align: center;
  font-family: "Font Awesome 5 Free";
  font-weight: 900;
}

.fa-folder::before {
  content: "\\f07b";
}

.fa-folder-open::before {
  content: "\\f07c";
}

.fa-file::before {
  content: "\\f15b";
}

.status-bar {
  background-color: var(--background-color);
  border-top: 1px solid var(--border-color);
  padding: 4px;
  font-size: 12px;
  min-height: 24px;
  box-sizing: border-box;
  color: var(--text-color);
}

.content {
  position: relative;
  width: 100%;
  height: 100%;
}

.content .monaco-editor {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  border: 0px;
}

.lm-TabBar-tab.preview-tab .lm-TabBar-tabLabel {
  font-style: italic;
}

.lm-TabBar-tab {
  display: flex;
  align-items: center;
  padding: 0 8px;
  background-color: var(--background-color);
  color: var(--text-color);
}

.lm-TabBar-tab.lm-mod-current {
  background-color: var(--tab-active-bg);
  color: var(--tab-active-text);
}

.lm-TabBar-tab:hover {
  background-color: var(--hover-color);
  color: var(--text-color);
}

.lm-TabBar-tabIcon {
  display: inline-block;
  vertical-align: middle;
  font-size: 14px;
  line-height: normal;
  margin-right: 4px;
}

.lm-TabBar-tabLabel {
  vertical-align: middle;
  line-height: normal;
}

.lm-TabBar-tabIcon.fa {
  font-family: "Font Awesome 5 Free";
  font-weight: 900;
}

body[data-theme="light"] .lm-MenuBar,
body[data-theme="dark"] .lm-MenuBar,
body[data-theme="high-contrast"] .lm-MenuBar {
  background-color: var(--background-color);
  color: var(--text-color);
  border-bottom: 1px solid var(--border-color);
}

body[data-theme="light"] .lm-MenuBar-item,
body[data-theme="dark"] .lm-MenuBar-item,
body[data-theme="high-contrast"] .lm-MenuBar-item {
  color: var(--text-color);
}

body[data-theme="light"] .lm-MenuBar-item.lm-mod-active,
body[data-theme="dark"] .lm-MenuBar-item.lm-mod-active,
body[data-theme="high-contrast"] .lm-MenuBar-item.lm-mod-active {
  background-color: var(--menu-active-bg);
  color: var(--menu-active-text);
}

body[data-theme="light"] .lm-TabBar-tab,
body[data-theme="dark"] .lm-TabBar-tab,
body[data-theme="high-contrast"] .lm-TabBar-tab {
  background-color: var(--background-color);
  color: var(--text-color);
}

body[data-theme="light"] .lm-TabBar-tab.lm-mod-current,
body[data-theme="dark"] .lm-TabBar-tab.lm-mod-current,
body[data-theme="high-contrast"] .lm-TabBar-tab.lm-mod-current {
  background-color: var(--tab-active-bg);
  color: var(--tab-active-text);
}

body[data-theme="light"] .lm-TabBar-tab:hover,
body[data-theme="dark"] .lm-TabBar-tab:hover,
body[data-theme="high-contrast"] .lm-TabBar-tab:hover {
  background-color: var(--hover-color);
  color: var(--text-color);
}

/* Styles for PDFViewerWidget */
.pdf-viewer-widget {
  min-width: 50px;
  min-height: 50px;
  display: flex;
  flex-direction: column;
  border: 1px solid var(--border-color);
  border-top: none;
  background: var(--background-color);
}

.pdf-viewer-container {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  /* Ensure container doesn't overflow its parent */
}

.pdf-viewer-controls {
  flex: 0 0 auto;
  padding: 4px;
  background-color: var(--background-color);
  border-bottom: 1px solid var(--border-color);
}

.pdf-viewer-controls button {
  margin-right: 4px;
}

.pdf-canvas-container {
  flex: 1 1 auto;
  overflow: auto;
  /* Enable scrolling when content overflows */
}

.pdf-canvas-container canvas {
  display: block;
  margin: 0 auto;
  /* Center the canvas horizontally */
}

.lm-Menu,
.lm-MenuBar-item,
.lm-Menu .lm-Menu-itemLabel,
.lm-Menu .lm-Menu-itemShortcut,
.lm-Menu .lm-Menu-itemIcon,
.lm-TabBar-tabLabel,
.lm-TabBar-tabIcon,
.lm-TabBar-tabCloseIcon,
.monaco-editor,
.monaco-editor .view-lines,
.monaco-editor .mtk0,
.monaco-editor .mtk1,
.monaco-editor .mtk2,
.monaco-editor .mtk3,
.monaco-editor .mtk4,
.monaco-editor .mtk5,
.monaco-editor .mtk6,
.monaco-editor .mtk7,
.monaco-editor .mtk8,
.monaco-editor .mtk9 {
  /*
    Windows browsers render opaque text layers with ClearType, which performs
    sub-pixel (RGB) anti-aliasing. It manipulates each color subpixel to boost
    horizontal resolution, resulting in sharper glyph edges but visible color
    fringing under magnification.

    When the compositor detects any non-opaque or transformed layer (opacity < 1,
    CSS transform, filter, etc.), it can no longer assume a fixed LCD subpixel
    layout. The text then moves off the “LCD text path” to the “non-LCD path,”
    where rendering falls back to grayscale anti-aliasing. Grayscale AA averages
    brightness uniformly across RGB, removing colored fringes and matching how
    native Windows menus, tab labels, and captions are drawn.

    Applying \`opacity: 0.999\` forces that GPU-composited path on these UI elements,
    disabling ClearType and ensuring a clean grayscale look for menu labels,
    shortcuts, icons, and Lumino tab labels—consistent with native Windows UI.
  */
  opacity: 0.999;
}
`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAGA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,yCAAyC;EACzC,wBAAwB;AAC1B;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;EACrB,wBAAwB;EACxB,sBAAsB;EACtB,oBAAoB;EACpB,yBAAyB;EACzB,2BAA2B;EAC3B,wBAAwB;EACxB,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;EACrB,wBAAwB;EACxB,sBAAsB;EACtB,uBAAuB;EACvB,yBAAyB;EACzB,2BAA2B;EAC3B,wBAAwB;EACxB,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;EACrB,wBAAwB;EACxB,sBAAsB;EACtB,uBAAuB;EACvB,yBAAyB;EACzB,2BAA2B;EAC3B,wBAAwB;EACxB,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,yCAAyC;EACzC,4CAA4C;AAC9C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;;EAGE,uCAAuC;EACvC,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,6BAA6B;EAC7B,YAAY;EACZ,eAAe;EACf,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,2CAA2C;EAC3C,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA,qCAAqC;AACrC;EACE,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,cAAc;EACd,UAAU;EACV,WAAW;AACb;;AAEA,iEAAiE;AACjE;EACE,cAAc;EACd,cAAc;EACd,UAAU;EACV,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;EAChB,2CAA2C;EAC3C,yCAAyC;EACzC,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,cAAc;EACd,yCAAyC;EACzC,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,qCAAqC;EACrC,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,cAAc;EACd,yCAAyC;EACzC,uCAAuC;EACvC,wBAAwB;AAC1B;;AAEA,6BAA6B;;AAE7B;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,wBAAwB;AAC1B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,sCAAsC;AACxC;;AAEA;;;EAGE,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yCAAyC;EACzC,yCAAyC;EACzC,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,yCAAyC;EACzC,wBAAwB;AAC1B;;AAEA;EACE,sCAAsC;EACtC,6BAA6B;AAC/B;;AAEA;EACE,oCAAoC;EACpC,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,eAAe;EACf,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;;;EAGE,yCAAyC;EACzC,wBAAwB;EACxB,4CAA4C;AAC9C;;AAEA;;;EAGE,wBAAwB;AAC1B;;AAEA;;;EAGE,uCAAuC;EACvC,8BAA8B;AAChC;;AAEA;;;EAGE,yCAAyC;EACzC,wBAAwB;AAC1B;;AAEA;;;EAGE,sCAAsC;EACtC,6BAA6B;AAC/B;;AAEA;;;EAGE,oCAAoC;EACpC,wBAAwB;AAC1B;;AAEA,+BAA+B;AAC/B;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,qCAAqC;EACrC,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,iDAAiD;AACnD;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,yCAAyC;EACzC,4CAA4C;AAC9C;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,4CAA4C;AAC9C;;AAEA;EACE,cAAc;EACd,cAAc;EACd,mCAAmC;AACrC;;AAEA;;;;;;;;;;;;;;;;;;;;EAoBE;;;;;;;;;;;;;;;;GAgBC;EACD,cAAc;AAChB","sourcesContent":["@import \"@lumino/widgets/style/index.css\";\r\n@import \"@lumino/default-theme/style/index.css\";\r\n\r\nbody {\r\n  display: flex;\r\n  flex-direction: column;\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  margin: 0;\r\n  padding: 0;\r\n  overflow: hidden;\r\n  background-color: var(--background-color);\r\n  color: var(--text-color);\r\n}\r\n\r\nbody[data-theme=\"light\"] {\r\n  --background-color: #ffffff;\r\n  --text-color: #000000;\r\n  --primary-color: #007aff;\r\n  --hover-color: #f0f0f0;\r\n  --border-color: #ccc;\r\n  --menu-active-bg: #007aff;\r\n  --menu-active-text: #ffffff;\r\n  --tab-active-bg: #e0e0e0;\r\n  --tab-active-text: #000000;\r\n}\r\n\r\nbody[data-theme=\"dark\"] {\r\n  --background-color: #1e1e1e;\r\n  --text-color: #d4d4d4;\r\n  --primary-color: #0a84ff;\r\n  --hover-color: #2a2a2a;\r\n  --border-color: #3c3c3c;\r\n  --menu-active-bg: #0a84ff;\r\n  --menu-active-text: #ffffff;\r\n  --tab-active-bg: #2d2d2d;\r\n  --tab-active-text: #ffffff;\r\n}\r\n\r\nbody[data-theme=\"high-contrast\"] {\r\n  --background-color: #000000;\r\n  --text-color: #ffffff;\r\n  --primary-color: #ffff00;\r\n  --hover-color: #1a1a1a;\r\n  --border-color: #ffffff;\r\n  --menu-active-bg: #ffff00;\r\n  --menu-active-text: #000000;\r\n  --tab-active-bg: #ffffff;\r\n  --tab-active-text: #000000;\r\n}\r\n\r\n#menuBar {\r\n  flex: 0 0 auto;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  background-color: var(--background-color);\r\n  border-bottom: 1px solid var(--border-color);\r\n}\r\n\r\n#menuBar .lm-MenuBar-item {\r\n  color: var(--text-color);\r\n}\r\n\r\n#menuBar .lm-MenuBar-item.lm-mod-active,\r\n#menuBar .lm-MenuBar-item:active,\r\n#menuBar .lm-MenuBar-item:hover {\r\n  background-color: var(--menu-active-bg);\r\n  color: var(--menu-active-text);\r\n}\r\n\r\n#themeToggleButton {\r\n  margin-right: 10px;\r\n  padding: 4px;\r\n  background-color: transparent;\r\n  border: none;\r\n  cursor: pointer;\r\n  font-size: 16px;\r\n  color: var(--text-color);\r\n}\r\n\r\n#themeToggleButton.light-theme-icon::before {\r\n  content: \"\\f185\";\r\n  font-family: \"Font Awesome 5 Free\";\r\n  font-weight: 900;\r\n}\r\n\r\n#themeToggleButton.dark-theme-icon::before {\r\n  content: \"\\f186\";\r\n  font-family: \"Font Awesome 5 Free\";\r\n  font-weight: 900;\r\n}\r\n\r\n#themeToggleButton.high-contrast-theme-icon::before {\r\n  content: \"\\f0eb\";\r\n  font-family: \"Font Awesome 5 Free\";\r\n  font-weight: 900;\r\n}\r\n\r\n#main {\r\n  flex: 1 1 auto;\r\n  display: flex;\r\n  flex-direction: row;\r\n  overflow: hidden;\r\n}\r\n\r\n#leftPanel {\r\n  width: 300px;\r\n  min-width: 200px;\r\n  border-right: 1px solid var(--border-color);\r\n  display: flex;\r\n  flex-direction: column;\r\n  overflow: hidden;\r\n  background-color: var(--background-color);\r\n}\r\n\r\n/* Adjust the CommandPalette styles */\r\n#leftPanel > .lm-CommandPalette {\r\n  /* Remove height: 100%; */\r\n  flex: 0 0 auto;\r\n  min-height: 250px;\r\n  overflow: auto;\r\n  z-index: 1;\r\n  border: 0px;\r\n}\r\n\r\n/* Ensure the directory-viewer-widget fills the remaining space */\r\n#leftPanel > .directory-viewer-widget {\r\n  flex: 1 1 auto;\r\n  overflow: auto;\r\n  z-index: 0;\r\n  border-top: 1px solid var(--border-color);\r\n}\r\n\r\n#palette {\r\n  min-width: 300px;\r\n  border-right: 1px solid var(--border-color);\r\n  background-color: var(--background-color);\r\n  color: var(--text-color);\r\n}\r\n\r\n#dock {\r\n  padding: 4px;\r\n  flex: 1 1 auto;\r\n  overflow: auto;\r\n  background-color: var(--background-color);\r\n  color: var(--text-color);\r\n}\r\n\r\n.content {\r\n  min-width: 50px;\r\n  min-height: 50px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  border: 1px solid var(--border-color);\r\n  border-top: none;\r\n  background: var(--background-color);\r\n}\r\n\r\n.content > div {\r\n  flex: 1 1 auto;\r\n  border: 1px solid var(--border-color);\r\n  overflow: auto;\r\n}\r\n\r\n.content input {\r\n  margin: 8px;\r\n}\r\n\r\n.directory-viewer-widget {\r\n  padding: 10px;\r\n  overflow: auto;\r\n  background-color: var(--background-color);\r\n  font: 13px Helvetica, Arial, sans-serif;\r\n  color: var(--text-color);\r\n}\r\n\r\n/* Add the new styles below */\r\n\r\n.directory-viewer-container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  flex: 1 1 auto;\r\n  overflow: auto;\r\n}\r\n\r\n.directory-tree {\r\n  list-style-type: none;\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n\r\n.directory-tree ul {\r\n  list-style-type: none;\r\n  margin: 0;\r\n  padding-left: 20px;\r\n}\r\n\r\n.directory-item {\r\n  cursor: pointer;\r\n  user-select: none;\r\n  position: relative;\r\n  padding: 4px 0;\r\n  color: var(--text-color);\r\n}\r\n\r\n.directory-item:hover {\r\n  background-color: var(--hover-color);\r\n}\r\n\r\n.directory-item .directory-icon {\r\n  margin-right: 5px;\r\n}\r\n\r\n.directory-item.collapsed > ul {\r\n  display: none;\r\n}\r\n\r\n.file-selected {\r\n  background-color: var(--primary-color);\r\n}\r\n\r\n.fa-folder,\r\n.fa-folder-open,\r\n.fa-file {\r\n  width: 16px;\r\n  display: inline-block;\r\n  text-align: center;\r\n  font-family: \"Font Awesome 5 Free\";\r\n  font-weight: 900;\r\n}\r\n\r\n.fa-folder::before {\r\n  content: \"\\f07b\";\r\n}\r\n\r\n.fa-folder-open::before {\r\n  content: \"\\f07c\";\r\n}\r\n\r\n.fa-file::before {\r\n  content: \"\\f15b\";\r\n}\r\n\r\n.status-bar {\r\n  background-color: var(--background-color);\r\n  border-top: 1px solid var(--border-color);\r\n  padding: 4px;\r\n  font-size: 12px;\r\n  min-height: 24px;\r\n  box-sizing: border-box;\r\n  color: var(--text-color);\r\n}\r\n\r\n.content {\r\n  position: relative;\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n\r\n.content .monaco-editor {\r\n  position: absolute;\r\n  top: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  left: 0;\r\n  border: 0px;\r\n}\r\n\r\n.lm-TabBar-tab.preview-tab .lm-TabBar-tabLabel {\r\n  font-style: italic;\r\n}\r\n\r\n.lm-TabBar-tab {\r\n  display: flex;\r\n  align-items: center;\r\n  padding: 0 8px;\r\n  background-color: var(--background-color);\r\n  color: var(--text-color);\r\n}\r\n\r\n.lm-TabBar-tab.lm-mod-current {\r\n  background-color: var(--tab-active-bg);\r\n  color: var(--tab-active-text);\r\n}\r\n\r\n.lm-TabBar-tab:hover {\r\n  background-color: var(--hover-color);\r\n  color: var(--text-color);\r\n}\r\n\r\n.lm-TabBar-tabIcon {\r\n  display: inline-block;\r\n  vertical-align: middle;\r\n  font-size: 14px;\r\n  line-height: normal;\r\n  margin-right: 4px;\r\n}\r\n\r\n.lm-TabBar-tabLabel {\r\n  vertical-align: middle;\r\n  line-height: normal;\r\n}\r\n\r\n.lm-TabBar-tabIcon.fa {\r\n  font-family: \"Font Awesome 5 Free\";\r\n  font-weight: 900;\r\n}\r\n\r\nbody[data-theme=\"light\"] .lm-MenuBar,\r\nbody[data-theme=\"dark\"] .lm-MenuBar,\r\nbody[data-theme=\"high-contrast\"] .lm-MenuBar {\r\n  background-color: var(--background-color);\r\n  color: var(--text-color);\r\n  border-bottom: 1px solid var(--border-color);\r\n}\r\n\r\nbody[data-theme=\"light\"] .lm-MenuBar-item,\r\nbody[data-theme=\"dark\"] .lm-MenuBar-item,\r\nbody[data-theme=\"high-contrast\"] .lm-MenuBar-item {\r\n  color: var(--text-color);\r\n}\r\n\r\nbody[data-theme=\"light\"] .lm-MenuBar-item.lm-mod-active,\r\nbody[data-theme=\"dark\"] .lm-MenuBar-item.lm-mod-active,\r\nbody[data-theme=\"high-contrast\"] .lm-MenuBar-item.lm-mod-active {\r\n  background-color: var(--menu-active-bg);\r\n  color: var(--menu-active-text);\r\n}\r\n\r\nbody[data-theme=\"light\"] .lm-TabBar-tab,\r\nbody[data-theme=\"dark\"] .lm-TabBar-tab,\r\nbody[data-theme=\"high-contrast\"] .lm-TabBar-tab {\r\n  background-color: var(--background-color);\r\n  color: var(--text-color);\r\n}\r\n\r\nbody[data-theme=\"light\"] .lm-TabBar-tab.lm-mod-current,\r\nbody[data-theme=\"dark\"] .lm-TabBar-tab.lm-mod-current,\r\nbody[data-theme=\"high-contrast\"] .lm-TabBar-tab.lm-mod-current {\r\n  background-color: var(--tab-active-bg);\r\n  color: var(--tab-active-text);\r\n}\r\n\r\nbody[data-theme=\"light\"] .lm-TabBar-tab:hover,\r\nbody[data-theme=\"dark\"] .lm-TabBar-tab:hover,\r\nbody[data-theme=\"high-contrast\"] .lm-TabBar-tab:hover {\r\n  background-color: var(--hover-color);\r\n  color: var(--text-color);\r\n}\r\n\r\n/* Styles for PDFViewerWidget */\r\n.pdf-viewer-widget {\r\n  min-width: 50px;\r\n  min-height: 50px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  border: 1px solid var(--border-color);\r\n  border-top: none;\r\n  background: var(--background-color);\r\n}\r\n\r\n.pdf-viewer-container {\r\n  flex: 1 1 auto;\r\n  display: flex;\r\n  flex-direction: column;\r\n  overflow: hidden;\r\n  /* Ensure container doesn't overflow its parent */\r\n}\r\n\r\n.pdf-viewer-controls {\r\n  flex: 0 0 auto;\r\n  padding: 4px;\r\n  background-color: var(--background-color);\r\n  border-bottom: 1px solid var(--border-color);\r\n}\r\n\r\n.pdf-viewer-controls button {\r\n  margin-right: 4px;\r\n}\r\n\r\n.pdf-canvas-container {\r\n  flex: 1 1 auto;\r\n  overflow: auto;\r\n  /* Enable scrolling when content overflows */\r\n}\r\n\r\n.pdf-canvas-container canvas {\r\n  display: block;\r\n  margin: 0 auto;\r\n  /* Center the canvas horizontally */\r\n}\r\n\r\n.lm-Menu,\r\n.lm-MenuBar-item,\r\n.lm-Menu .lm-Menu-itemLabel,\r\n.lm-Menu .lm-Menu-itemShortcut,\r\n.lm-Menu .lm-Menu-itemIcon,\r\n.lm-TabBar-tabLabel,\r\n.lm-TabBar-tabIcon,\r\n.lm-TabBar-tabCloseIcon,\r\n.monaco-editor,\r\n.monaco-editor .view-lines,\r\n.monaco-editor .mtk0,\r\n.monaco-editor .mtk1,\r\n.monaco-editor .mtk2,\r\n.monaco-editor .mtk3,\r\n.monaco-editor .mtk4,\r\n.monaco-editor .mtk5,\r\n.monaco-editor .mtk6,\r\n.monaco-editor .mtk7,\r\n.monaco-editor .mtk8,\r\n.monaco-editor .mtk9 {\r\n  /*\r\n    Windows browsers render opaque text layers with ClearType, which performs\r\n    sub-pixel (RGB) anti-aliasing. It manipulates each color subpixel to boost\r\n    horizontal resolution, resulting in sharper glyph edges but visible color\r\n    fringing under magnification.\r\n\r\n    When the compositor detects any non-opaque or transformed layer (opacity < 1,\r\n    CSS transform, filter, etc.), it can no longer assume a fixed LCD subpixel\r\n    layout. The text then moves off the “LCD text path” to the “non-LCD path,”\r\n    where rendering falls back to grayscale anti-aliasing. Grayscale AA averages\r\n    brightness uniformly across RGB, removing colored fringes and matching how\r\n    native Windows menus, tab labels, and captions are drawn.\r\n\r\n    Applying `opacity: 0.999` forces that GPU-composited path on these UI elements,\r\n    disabling ClearType and ensuring a clean grayscale look for menu labels,\r\n    shortcuts, icons, and Lumino tab labels—consistent with native Windows UI.\r\n  */\r\n  opacity: 0.999;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
